import { ForwardedRef, forwardRef, PropsWithChildren } from 'react';

import { ListMode } from '../../utils/types/stateful-list.types';
import { ItemListWrapper } from '../item-list-wrapper/item-list-wrapper';
import ListSearch from '../search/list-search';

import { TagsSelectContext } from './tags-select.context';
import { TagsSelectProps } from './tags-select.types';
import { useTagsState } from './use-tags-state';

export const TagSelectProvider = forwardRef(
  (props: PropsWithChildren<TagsSelectProps>, ref?: ForwardedRef<HTMLDivElement>) => {
    const value = useTagsState(props);

    return (
      <TagsSelectContext.Provider value={value}>
        <ItemListWrapper
          {...props}
          ref={ref}
          activeDescendantId={value.activeDescendantId}
          containerRef={value.containerRef}
          onKeyDown={value.onKeyDown}
          renderItems={value.renderItems}
          mode={ListMode.Tags}
        >
          <ListSearch
            search={value.search}
            setSearch={value.setSearch}
            searchPlaceholder={props.searchPlaceholder}
            focusId={`focusable-item-search-input-${value.renderItems.id}`}
            activeDescendantId={value.activeDescendantId}
            maxLength={value.maxTagChar}
          />
        </ItemListWrapper>
      </TagsSelectContext.Provider>
    );
  }
);

export default TagSelectProvider;
